<template>
	<div>
		<div class="wrap">
			<Title title="活动管理"></Title>
			<div class="activity-form-wrap">
				<el-form :inline="true" :model="activityForm" class="activity-form">
					<el-form-item label="活动名称">
						<el-input v-model="activityForm.vacationName" placeholder="请输入活动名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="审核状态">
						<el-select v-model="activityForm.auditStatus" @change="setSelectedAudit">
							<el-option label="审核中" value="1"></el-option>
							<el-option label="未审核" value="0"></el-option>
							<el-option label="审核通过" value="2"></el-option>
							<el-option label="审核不通过 " value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布状态">
						<el-select v-model="activityForm.publishStatus" @change="setSelectedPublish">
							<el-option label="未发布" value="0"></el-option>
							<el-option label="已发布" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button icon="el-icon-plus" size="mini" type="primary" @click="addActivity">发起活动</el-button>
			</div>
			<el-table border :data="activityList" style="width: 100%">
				<el-table-column prop="vacationName" label="活动名称" height="30">
				</el-table-column>
				<el-table-column prop="activityType" label="活动类型" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.activityType==0">包裹发放</span>
						<span v-else>最美推荐</span>
					</template>
				</el-table-column>
				<el-table-column prop="recruitNames" label="招募范围" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.recruitType==0">全国</span>
						<span v-if="scope.row.recruitType==1">{{scope.row.recruitNames}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="recruitNums" label="招募人数" width="70">
				</el-table-column>
				<el-table-column prop="recruitTime" label="报名时间" width="100">
				</el-table-column>
				<el-table-column prop="addTime" label="创建时间">
					<template slot-scope="scope">
						<span>{{scope.row.addTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="发布时间">
					<template slot-scope="scope">
						<span>{{scope.row.publishTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="auditStatus" label="审核状态" width="100">
					<template slot-scope="scope">
						<el-button v-if="scope.row.auditStatus==0" size="mini" type="danger" plain>未审核</el-button>
						<el-button v-if="scope.row.auditStatus==1" size="mini" type="danger" plain>审核中</el-button>
						<el-button v-if="scope.row.auditStatus==2" size="mini" type="success" plain>审核通过</el-button>
						<el-button v-if="scope.row.auditStatus==3" size="mini" type="danger" plain>审核不通过</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="publishStatus" label="发布状态" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.publishStatus==0">未发布</span>
						<span v-else>已发布</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-dropdown>
							<span class="el-dropdown-link">
								...
							</span>
							<el-dropdown-menu slot="dropdown" class="dropdown-new">
								<el-dropdown-item v-if="scope.row.auditStatus==0||scope.row.auditStatus==3" @click.native="toCheckActivity(scope.row,1)">提交审核</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.auditStatus==1" @click.native="toCheckActivity(scope.row,0)">撤回</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishFlag==1" @click.native="toPublish(scope.row)">发布</el-dropdown-item>

								<el-dropdown-item @click.native="templateActivity(scope.row)">用户确认提醒</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.auditStatus!=1" @click.native="modifyActivity(scope.row)">修改</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.auditStatus==0||scope.row.auditStatus==3" @click.native="deleteActivity(scope.row)">删除</el-dropdown-item>

								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toEnroll(scope.row)">报名审核</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.auditStatus==0||scope.row.auditStatus==3" @click.native="toTask(scope.row)">任务管理</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toCertificate(scope.row)">实践证书</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toSignature(scope.row)">签收</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toFeedList(scope.row)">动态</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toMessageList(scope.row)">消息</el-dropdown-item>
								<el-dropdown-item @click.native="detailActivity(scope.row)">详情</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1" @click.native="toVoteList(scope.row)">投票管理</el-dropdown-item>
								<el-dropdown-item @click.native="toContract(scope.row)">合同管理</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.publishStatus==1&&scope.row.activityType==0" @click.native="toReport(scope.row)">活动数据报告</el-dropdown-item>


								<!-- <el-dropdown-item>报名审核</el-dropdown-item>
								<el-dropdown-item>实践证书</el-dropdown-item>
								<el-dropdown-item>动态</el-dropdown-item>
								<el-dropdown-item>消息</el-dropdown-item>
								<el-dropdown-item>活动数据报告</el-dropdown-item>


								<el-dropdown-item>合同管理</el-dropdown-item> -->
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
			<!--提示模板弹窗-->
			<el-dialog title="用户确认参加活动的提醒内容设置" :visible.sync="templateDialog" width="50%" @close="colseTemplate">
				<el-form :model="templateForm" :rules="templateRules" ref="templateForm">
					<el-form-item label="提示内容:" prop="confirmMessage">
						<el-input v-model="templateForm.confirmMessage" :rows="6" type="textarea" clearable placeholder="用户确认参加活动的提醒内容设置"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="flex-end">
							<el-button size="mini" type="primary" @click="toConfirm">确定</el-button>
						</div>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	export default {
		name: 'ActivityList',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				pageSize: 10,
				pageNum: 1,
				total: 0,
				activityForm: {
					vacationName: '',
					auditStatus: '',
					publishStatus: ''
				},
				activityList: [],
				companyId: '',
				templateDialog: false,
				templateForm: {
					confirmMessage: '',
					confirmId: ''
				},
				templateRules:{
					confirmMessage: [{
						required: true,
						message: '请输入提示内容',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.companyId = localStorage.getItem('companyId')
			this.getActivityList()
		},
		methods: {
			setSelectedAudit(e){
				this.activityForm.auditStatus = e
				this.pageNum = 1
				this.activityList = []
				this.getActivityList()
			},
			setSelectedPublish(e){
				this.activityForm.publishStatus = e
				this.pageNum = 1
				this.activityList = []
				this.getActivityList()
			},
			//获取活动列表
			async getActivityList(){
				let param = {
					startCompanyId: localStorage.getItem('companyId'),
					vacationName: this.activityForm.vacationName,
					auditStatus: this.activityForm.auditStatus,
					publishStatus: this.activityForm.publishStatus,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/vacation/list', qs.stringify(param))
				console.log(res.data.page.items)
				if (res.data.code == 200) {
					this.activityList = res.data.page.items
					this.total = res.data.page.count
				}
			},
			toSearch(){
				this.pageNum = 1
				this.total = 0
				this.getActivityList()
			},
			toReset(){
				this.activityForm =  {
					vacationName: '',
					auditStatus: '',
					publishStatus: ''
				}
				this.pageNum = 1
				this.activityList = []
				this.getActivityList()
			},
			addActivity(){
				this.$router.push({
					path: '/admin/addActivity'
				})
			},
			//提示模板
			templateActivity(row) {
				this.templateDialog = true
				this.templateForm.id = row.id
				if(row.confirmMessage) {
					this.templateForm.confirmMessage = row.confirmMessage
				}
			},
			//提交提示模板
			toConfirm(){
				this.$refs.templateForm.validate( async valid =>{
					if(valid){
						//提交
						let param = {
							id: this.templateForm.id,
							confirmMessage: this.templateForm.confirmMessage
						}
						console.log(param)
						ajaxParam(param)
						const res = await post('admin/vacation/saveOrUpdateConfirmMessage', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('提交成功！')
							this.templateDialog = false
							this.getActivityList()
						}
					}
				})
			},
			//关闭提示模板
			colseTemplate(){
				this.templateDialog =false
				this.templateForm.confirmMessage = ''
				this.templateForm.id = ''
			},
			//投票记录
			toVoteList(row){
				this.$router.push({
					path: '/admin/activity/activityVote?id='+row.id
				})
			},
			//去动态
			toFeedList(row){
				this.$router.push({
					path: '/admin/activity/feed?id='+row.id
				})
			},
			//实践证书
			toCertificate(row){
				this.$router.push({
					path: '/admin/activity/certificate?id='+row.id
				})
			},
			//消息列表
			toMessageList(row){
				this.$router.push({
					path: '/admin/activity/message?id='+row.id
				})
			},
			//任务列表
			toTask(row){
				this.$router.push({
					path: '/admin/activity/task?id='+row.id
				})
			},
			//报名审核
			toEnroll(row){
				//判断是否已经添加消息模版提示
				
				if(row.confirmMessage =='' || row.confirmMessage == undefined ||row.confirmMessage == "undefined" ){
					

					this.$confirm('您还没有添加用户确认提醒,去填写吗？', '温馨提示', {
							confirmButtonText: '去填写',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(async () => {
						
							this.templateActivity(row)
						}).catch(() => {
							console.log('取消')
							//添加任务
						})
					
					
				}else{
					this.$router.push({
						path: '/admin/activity/enroll?id='+row.id
					})
				}

				
			},
			//去签收
			toSignature(row){
				this.$router.push({
					path: '/admin/activity/signature?id='+row.id
				})
			},
			//合同管理
			toContract(row){
				this.$router.push({
					path: '/admin/activity/contract?id='+row.id
				})
			},
			//活动数据报告
			toReport(row){
				this.$router.push({
					path: '/admin/activity/report?id='+row.id
				})
			},
			//详情
			detailActivity(row) {
				console.log('===')
				console.log(row.id)
				this.$router.push({
					path: '/admin/activity/detail?id='+row.id
				})
			},
			//修改活动
			modifyActivity(row){
				this.$router.push({
					path: '/admin/addActivity?id='+row.id
				})
			},
			//删除活动
			async deleteActivity(row) {
				this.$confirm('确定要删除活动吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id
					}
					ajaxParam(param)
					const res = await post('admin/vacation/delete', qs.stringify(param))
					if (res.data.code == 200) {
						this.$message.success('删除成功！')
						this.activityList.forEach((item,index)=>{
							if(item.id==row.id){
								this.activityList.splice(index,1)
							}
						})
					}
				}).catch(() => {

				})
			},
			//提交审核撤销
			toCheckActivity(row,flag){
				if(flag==1) {
					//先判断该活动下有没有任务，如果有直接提交，如果没有，弹出提示框
					this.chekHaveTask(row,flag)
				} else{
					//撤销审核
					this.$confirm('确定要撤回审核吗？', '温馨提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.checkActivity(row,flag)
					}).catch(() => {

					})
				}
			},
			//提交审核和撤销方法
			async checkActivity(row,flag) {
				let param = {
					id: row.id,
					flag: flag  //1提交审核  0撤回
				}
				ajaxParam(param)
				const res = await post('admin/vacation/operaAudit', qs.stringify(param))
				if (res.data.code == 200) {
					this.getActivityList()
				}
			},
			//判断该活动下是否有任务
			async chekHaveTask(row,flag){
				let param = {
					vacationId: row.id
				}
				console.log('================')
				console.log(param)
				ajaxParam(param)
				const res = await post('admin/task/getIsAddBySearch', qs.stringify(param))
				if (res.data.code == 200) {
					console.log('成功')
					let isAdd = res.data.entity.isAdd
					if(isAdd=='1') {
						//表示已添加任务，直接提交
						this.checkActivity(row,flag)
					} else {
						//表示未添加任务弹窗提示
						this.$confirm('您还没有添加活动任务,继续提交吗？', '温馨提示', {
							confirmButtonText: '继续提交',
							cancelButtonText: '添加任务',
							type: 'warning'
						}).then(async () => {
							//提交审核
							this.checkActivity(row,flag)
						}).catch(() => {
							console.log('取消')
							//添加任务
							this.toTask(row)
						})
					}
				}
			},
			//发布任务
			async toPublish(row){
				this.$confirm('确定要发布吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						vacationId: row.id,
						userId: localStorage.getItem('userId'),
						userName: localStorage.getItem('userName')
					}
					ajaxParam(param)
					const res = await post('admin/vacation/operaPublishStatus', qs.stringify(param))
					if (res.data.code == 200) {
						this.$message.success('发布成功！')
						setTimeout(res=>{
							this.getActivityList()
						},300)
					}
				}).catch(() => {

				})
			},
			//分页
			handleCurrentChange(e){
				this.activityList = []
				console.log('-----------------')
				console.log(e)
				this.pageNum = e.number
				this.getActivityList()
			},
		}
	}
</script>

<style scoped lang="less">
	.wrap /deep/ .el-table .el-table__cell {
		padding: 6px 0 !important;
		font-size: 12px;
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.pagination {
		margin-top: 10px;
	}

	.title /deep/ .el-button--warning {
		background-color: #EB6B1B
	}

	.title /deep/ .el-button--mini {
		padding: 4px 10px;
	}

	.activity-form-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
	}
	.dropdown-new{
		li{
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			color: #EB6B1B;
		}
		li:hover{
			background: none;
			text-decoration: underline;
			color: #EB6B1B;
		}
	}
	.flex-end{
		display: flex;
		justify-content: flex-end;
		padding-top: 20px;
		/deep/ .el-button--mini,
		.el-button--mini.is-round {
			padding: 4px 15px;
			font-size: 14px!important;
		}

	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}
	/deep/ .el-dropdown{
		color: #EB6B1B;
	}
	/deep/ .el-dialog__header {
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #DBDCDC !important;
	}
	/deep/ .el-dialog__body {
		padding-top: 10px;
	}
</style>
